import axios from "axios";

const api = axios.create({
  //baseURL:"http://localhost:5000",
  baseURL:"https://api.maksasoft.com",
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default api;


